// `whiteboard.region` (範囲の移動・コピー) broadcast の型と parse。
// 形の正は protocol の `whiteboardRegionSchema` (docs/_wip/region-move-2026-10-15.md)。
// このファイルは engine が使う名前 (`RegionBroadcast` / `parseRegionBroadcast`) を保つ薄い層。

import { type WhiteboardRegion, whiteboardRegionSchema } from '@oekaki/protocol';

export type RegionBroadcast = WhiteboardRegion;
export type RegionBroadcastItem = WhiteboardRegion['items'][number];

/** 形が合う `whiteboard.region` だけ返す (合わなければ null)。 */
export const parseRegionBroadcast = (ev: unknown): RegionBroadcast | null => {
  if (typeof ev !== 'object' || ev === null) return null;
  if ((ev as { t?: unknown }).t !== 'whiteboard.region') return null;
  const r = whiteboardRegionSchema.safeParse(ev);
  return r.success ? r.data : null;
};
